import { isMobile } from '.'

const isDesktop = () => {
  return !isMobile()
}

export default isDesktop
